const capitalizeFirstLetter = (text: string): String => {
  if (text) {
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  }
  return "";
};

export default capitalizeFirstLetter;
